const indexItems = [
  { title: '国产剧全集', icon: 'ri-tv-line', count: '3.2万部', color: 'primary' },
  { title: '韩剧大全', icon: 'ri-heart-line', count: '8,600部', color: 'accent' },
  { title: '美剧精选', icon: 'ri-global-line', count: '1.5万部', color: 'secondary' },
  { title: '日剧专区', icon: 'ri-sun-line', count: '6,200部', color: 'primary' },
  { title: '悬疑推理', icon: 'ri-search-eye-line', count: '1.8万部', color: 'accent' },
  { title: '古装仙侠', icon: 'ri-moon-line', count: '9,400部', color: 'secondary' },
  { title: '甜宠爱情', icon: 'ri-heart-pulse-line', count: '1.2万部', color: 'primary' },
  { title: '科幻巨制', icon: 'ri-rocket-line', count: '5,700部', color: 'accent' },
  { title: '动作冒险', icon: 'ri-speed-up-line', count: '1.1万部', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; icon: string; badge: string }> = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-600', badge: 'bg-primary-50 text-primary-700' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-600', badge: 'bg-accent-50 text-accent-700' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-600', badge: 'bg-secondary-50 text-secondary-700' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            剧集索引
          </h2>
          <p className="text-sm text-foreground-500">按分类浏览12万+影视资源，快速找到想看的类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <a
                key={i}
                href={`#ranking`}
                className="group flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl p-3 md:p-4 border border-background-200/70 hover:border-primary-300 hover:shadow-md transition-all cursor-pointer"
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-xl ${c.bg} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} text-lg md:text-xl ${c.icon}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-label text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className={`inline-block px-1.5 py-0.5 rounded text-xs ${c.badge}`}>
                    {item.count}
                  </span>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}